import type { IntlShape } from 'react-intl';
import type { ToolUseItem } from '../../../../contracts/harness.types';

import {
  renderStandardExportToolUse,
  type OpenExportDocumentPayload,
} from './shared/exportDocumentPreview';

import type { JSX } from 'react';

export const renderCreatePatientEvidencePdfToolUse = (
  item: ToolUseItem,
  intl: IntlShape,
  onOpenDocumentExport?: (payload: OpenExportDocumentPayload) => void
): JSX.Element | null =>
  renderStandardExportToolUse(
    item,
    intl,
    {
      artefactType: 'patient_handout',
      titleFallback: { id: 'pjArtPev06', defaultMessage: 'Patient evidence PDF' },
    },
    onOpenDocumentExport
  );
